import { render, staticRenderFns } from "./TaxDialog.vue?vue&type=template&id=a40aa702&scoped=true"
import script from "./TaxDialog.vue?vue&type=script&lang=js"
export * from "./TaxDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40aa702",
  null
  
)

export default component.exports